// import service from "@/store/services/md-makes-service";
import Service from "@/helpers/py-service";

const state = {
  loading: false,
  list: [],
  listByID: {},
  meta: {},
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_MAKE_BY_ID(state, payload) {
    state.listByID = payload;
  },

  ADD_LIST(state, payload) {
    state.list.push(payload);
  },

  UPDATE_LIST(state, payload) {
    const item = state.list.find((item) => item.id === payload.id);
    Object.assign(item, payload);
  },

  DELETE_LIST(state, payload) {
    state.list.splice(state.list.map((o) => o.id).indexOf(payload.id), 1);
  },

  SET_LOADING(state, value) {
    state.loading = value;
  },
};

const actions = {
  setLoadingValue: (store, value) => {
    store.commit("SET_LOADING", value);
  },
  list: (store, params) => {
    store.state.loading = true;
    return Service.get(`vehicle/md-makes`, params).then((data) => {
      if (params.page) {
        store.commit("SET_LIST", data.body.data);
        store.commit("SET_META", data.body);
      } else {
        store.commit("SET_LIST", data.body);
      }
      store.state.loading = false;
      return data.body;
    });
  },
  show: (store, params) => {
    store.state.loading = true;
    return Service.get(`vehicle/md-makes/${params.id}`, params).then((data) => {
      store.commit("SET_MAKE_BY_ID", data.body);
      store.state.loading = false;
      return data.body;
    });
  },

  add: (store, { mdMake, filter }) => {
    store.state.loading = true;
    return Service.post(`vehicle/md-makes`, mdMake).then((data) => {
      store.commit("ADD_LIST", data.body);
      store.dispatch("list", filter);
      store.state.loading = false;
      return data.body;
    });
  },

  update: (store, params) => {
    store.state.loading = true;
    return Service.put(`vehicle/md-makes/${params.id}`, params).then((data) => {
      store.commit("UPDATE_LIST", data.body);
      store.state.loading = false;
      return data.body;
    });
  },

  destroy: (store, params) => {
    store.state.loading = true;
    return Service.destroy(`vehicle/md-makes/${params.id}`, params).then(
      (data) => {
        store.commit("DELETE_LIST", params);
        store.state.loading = false;
        return data.body;
      }
    );
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  meta(state) {
    return state.meta;
  },
  listMdMakes(state) {
    return state.list;
  },
  getMdMakeById(state) {
    return state.listByID;
  },
  activelistMdMakes() {
    return state.list.filter((r) => r.is_active == true);
  },
};

const mdMake = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default mdMake;
